import React, { useState, useEffect } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";

export const MonthlyBalanceData = (props) => {
  const [rowDataParams, setRowDataParams] = useState(null);
  const rowHeight = 24;
  const maxHeight = window.innerHeight - 230;

  useEffect(() => {
    setRowDataParams(props.data);
  }, []);

  const getCellStyle = (params) => {
    var style = {};
    style["cursor"] = "default";
    return style;
  };
  return (
    <div style={{ padding: "25px 25px 40px 25px", backgroundColor: "white" }}>
      <div
        style={{
          width: "100%",
          margin: "0px auto -20px auto",
        }}
        className="ag-theme-balham"
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            sortable: true,
            resizable: true,
            minWidth: 60,
            maxWidth: 1200,
            flex: 1,
            filterParams: { buttons: ["reset"] },
            cellStyle: getCellStyle,
          }}
          getContextMenuItems={(params) => [
            "copy",
            "copyWithHeaders",
            "paste",
            "separator",
            {
              name: "Export",
              icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
              subMenu: [
                "csvExport",
                {
                  name: "Excel Export (.xlsx)",
                  icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                  action: () => {
                    params.api.exportDataAsExcel({ sheetName: "Export" });
                  },
                },
              ],
            },
          ]}
          rowData={rowDataParams}
          getRowHeight={(params) => {
            return rowHeight;
          }}
          domLayout="autoHeight"
          popupParent={document.body}
          suppressDragLeaveHidesColumns={true}
          stopEditingWhenGridLosesFocus={true}
          singleClickEdit={true}
        >
          <AgGridColumn field="Month" headerName="Month" />
          <AgGridColumn
            field="pow_alt_cur"
            headerName="Power in alternate current (MWh)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
          />
        </AgGridReact>
      </div>
    </div>
  );
};

export default MonthlyBalanceData;
